import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Paper, Alert, CircularProgress } from '@mui/material';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useNavigate } from 'react-router-dom';

const AdminRegistration = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Validation des champs
    if (password !== confirmPassword) {
      return setError('Les mots de passe ne correspondent pas.');
    }
    
    if (password.length < 6) {
      return setError('Le mot de passe doit contenir au moins 6 caractères.');
    }

    // Validation de l'email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return setError('Veuillez entrer une adresse email valide.');
    }

    setLoading(true);

    try {
      // Enregistrement de la demande d'administrateur dans Firestore
      await addDoc(collection(db, 'admin_requests'), {
        name,
        email,
        password, // Note: Dans un environnement de production, il serait préférable de ne pas stocker le mot de passe en clair
        status: 'pending', // Statut en attente de validation
        createdAt: serverTimestamp()
      });

      console.log('Demande d\'administrateur soumise avec succès');
      setSuccess(true);
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Erreur d\'inscription détaillée:', error);
      
      // Gestion des erreurs Firestore
      if (error.code) {
        console.log('Code d\'erreur Firebase:', error.code);
        
        if (error.code === 'permission-denied') {
          setError('Accès refusé. Vous n\'avez pas les permissions nécessaires.');
        } else if (error.code === 'already-exists') {
          setError('Cet email est déjà utilisé pour une demande d\'administrateur.');
        } else if (error.code === 'unavailable') {
          setError('Service indisponible. Veuillez vérifier votre connexion internet.');
        } else {
          setError('Une erreur est survenue lors de l\'inscription. Veuillez réessayer.');
        }
      } else if (error.message) {
        setError(error.message);
      } else {
        setError('Une erreur est survenue lors de l\'inscription. Veuillez réessayer.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '80vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Paper elevation={3} sx={{ 
        p: 4, 
        width: '100%', 
        maxWidth: '400px',
        borderRadius: '10px'
      }}>
        <Typography variant="h5" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold', color: '#014527' }}>
          Demande d'Inscription Administrateur
        </Typography>
        
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>Demande d'inscription soumise avec succès! Un administrateur existant validera votre compte. Redirection...</Alert>}
        
        <form onSubmit={handleSubmit}>
          <TextField
            label="Nom complet"
            fullWidth
            margin="normal"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            sx={{ mb: 2 }}
          />
          
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{ mb: 2 }}
          />
          
          <TextField
            label="Mot de passe"
            type="password"
            fullWidth
            margin="normal"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ mb: 2 }}
            helperText="Le mot de passe doit contenir au moins 6 caractères"
          />
          
          <TextField
            label="Confirmer le mot de passe"
            type="password"
            fullWidth
            margin="normal"
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            sx={{ mb: 3 }}
          />
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{ 
              py: 1.5, 
              backgroundColor: '#014527',
              '&:hover': {
                backgroundColor: '#01331d',
              }
            }}
          >
            {loading ? <CircularProgress size={24} /> : 'S\'inscrire'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default AdminRegistration;